export default {
    description: "Descrição",
    orderingNote: "Nota de pedido"
}